import React from 'react';
import { HtmlElementDefaults } from '../../type/HtmlElementDefaults';
import clsx from 'clsx';
import './XSText.css';
import { Styles } from '../../type/Styles';
import { XSSection } from '../section/XSSection';

type Input = HtmlElementDefaults & {
    size?: 'default' | 'sm' | 'lg';
    type?: 'label' | 'title' | 'subtitle';
    color?: Styles.Color | 'ghost';
    transform?: 'uppercase';
    weight?: 'normal' | 'bold';
    align?: 'left' | 'center' | 'right';
};

export function XSText(input: Input) {
    const { className, type, color, size, transform, weight, align, ...rest } = input;

    const element = (
        <span
            className={clsx(
                className,
                `XSText type-${type || ''} color-${color || ''} size-${size || ''} transform-${
                    transform || ''
                } weight-${weight || ''} align-${align || ''}`,
            )}
            {...rest}
        />
    );

    return element;
}
